/*
 * @Author: your name
 * @Date: 2022-03-01 14:03:04
 * @LastEditTime: 2022-03-30 22:16:59
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\mobile\plugins\initialize\phpstatdata.ts
 */
export async function StartPhpstatdata() {
  // 不主动触发埋点了，通过 easytoanalyze.min.js 自动执行
};
